








import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class GtImage extends Vue {
  // 错误图片地址
  @Prop({ type: [String] }) errorImage: NodeRequire | string;
}
